import classNames from 'classnames';
import type React from 'react';
import { Link } from 'react-router-dom';

interface SidebarLinkProps {
  text: string;
  icon: React.JSX.Element;
  isActive: boolean;
  to: string;
  extra?: React.ReactNode;
}

export const SidebarLink: React.FC<SidebarLinkProps> = ({ text, icon, isActive, to, extra }) => (
  <Link to={to}>
    <div
      className={classNames(
        'flex items-center pl-16 pr-4 py-[9px] rounded-lg cursor-pointer ease duration-100 hover:opacity-100',
        {
          'opacity-70': !isActive,
          'bg-gray-14': isActive,
        },
      )}
    >
      <div>{icon}</div>

      <div className={classNames('ml-12 text-[14px]/[22px]', { 'font-medium': isActive })}>
        {text}
        {extra && <span className="inline-flex items-center align-middle ml-4">{extra}</span>}
      </div>
    </div>
  </Link>
);
